import styled from 'styled-components'
import {
  alignItems,
  AlignItemsProps,
  flexDirection,
  FlexDirectionProps,
  justifyContent,
  JustifyContentProps,
  margin,
  MarginProps,
  position,
  PositionProps,
  zIndex,
  ZIndexProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<AlignItemsProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: ${themeGet('space.13')}px;
  background-color: ${themeGet('colors.background.screenAlt')};

  @media screen and (min-width: ${themeGet('breakpoints.4')}) {
    border-top-right-radius: 16px;
    width: 50%;
  }

  ${alignItems}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;

  > svg {
    width: 30px;
    height: 30px;
    color: ${themeGet('colors.primary.main')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    > svg {
      width: 35px;
      height: 35px;
    }
  }

  ${flexDirection}
`
export const CommunityHolder = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & MarginProps & JustifyContentProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.4')}px;

  ${margin}
  ${flexDirection}
  ${justifyContent}
`

export const Avatars = styled.div`
  position: relative;
  width: 106px;
  height: 46px;
  display: flex;
`

export const Avatar = styled.div.withConfig({
  shouldForwardProp,
})<PositionProps & ZIndexProps>`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 23px;
  border: 2px solid ${themeGet('colors.line.primary')};

  ${position}
  ${zIndex}
`
